import React, { useRef } from "react";

interface TimeInputProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
}

const TimeInput: React.FC<TimeInputProps> = ({ label, name, value, onChange, required }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const openPicker = () => {
    inputRef.current?.showPicker?.();
  };

  return (
    // <div className="flex flex-col sm:flex-row items-center">
    //   <label className="block text-sm font-medium mb-1 sm:mb-0 mr-2">{label}</label>
    //   <div onClick={openPicker} className="w-full sm:w-auto">
    //     <input
    //       ref={inputRef}
    //       type="time"
    //       name={name}
    //       value={value}
    //       onChange={onChange}
    //       required={required}
    //       className="w-full max-w-full min-w-0 border rounded px-3 py-2 cursor-pointer bg-white/90 text-black/90"
    //     />
    //   </div>
    // </div>

    <div>
    <label className="block text-sm font-medium mb-1">{label}</label>
    <div onClick={openPicker}>
      <input
        ref={inputRef}
        type="time"
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className="w-full border rounded text-sm px-3 py-2 cursor-pointer bg-white/90 text-black/90"
      />
    </div>
  </div>
  );
};

export default TimeInput;
